import { graphql } from "gql";

const SUGGEST_SUBJECT_OR_TITLE_QUERY = graphql(`
  query SuggestSubjectOrTitle($input: SuggestSubjectOrTitleInput!) {
    suggestSubjectOrTitle(input: $input)
  }
`);

export default SUGGEST_SUBJECT_OR_TITLE_QUERY;
